<template>
  <b-modal
    centered
    hide-footer
    v-model="show"
    class="pa-4"
    :style="'width: 708px !important;'"
  >
    <template #modal-title>
      <h3 class="font-weight-bold">Purchasing Token</h3>
    </template>
    <b-card
      no-body
      v-cloak
      class="rounded-0 border-0 mx-0 bg-light"
      @drop.prevent=""
      @dragover.prevent
    >
      <b-form @submit.prevent="onSubmit">
        <b-row>
          <b-col>
            <b-form-group label="Current Balance">
              <div :style="tokenColour">
                Available:
                <strong>{{ (balance && balance.available) || 0 }}</strong>
              </div>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col>
            <b-form-group label="Quantity">
              <b-form-input
                v-model.number="localTokenQuantity"
                type="number"
                min="1"
                required
                placeholder="Enter Quantity"
              >
              </b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row align-h="center" class="p-2 token-modal-footer">
          <b-button
            variant="outline-secondary"
            class="mx-2 token-modal-btn"
            @click="onClose"
          >
            CANCEL
          </b-button>
          <b-button
            type="submit"
            variant="primary"
            class="mx-2 token-modal-btn"
            :disabled="!localTokenQuantity || localTokenQuantity < 1"
          >
            PURCHASE
          </b-button>
        </b-row>
      </b-form>
    </b-card>
  </b-modal>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'PurchaseTokenModal',

  props: {
    showModal: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      localTokenQuantity: 1,
    }
  },

  computed: {
    ...mapGetters('token', ['balance']),

    show: {
      get() {
        return this.showModal
      },
      set(value) {
        this.$emit('closeModal')
      },
    },

    tokenColour() {
      if (this.balance && this.balance.available !== undefined) {
        if (this.balance.available <= 3) {
          return {
            backgroundColor: '#dc3545',
            color: '#ffffff',
            padding: '8px 16px',
            borderRadius: '6px',
            display: 'inline-block',
            fontWeight: '500',
          }
        } else if (this.balance.available > 3 && this.balance.available <= 10) {
          return {
            backgroundColor: '#ffc107',
            color: '#000000',
            padding: '8px 16px',
            borderRadius: '6px',
            display: 'inline-block',
            fontWeight: '500',
          }
        } else
          return {
            backgroundColor: '#28a745',
            color: '#ffffff',
            padding: '8px 16px',
            borderRadius: '6px',
            display: 'inline-block',
            fontWeight: '500',
          }
      }
      return {
        backgroundColor: '#dc3545',
        color: '#ffffff',
        padding: '8px 16px',
        borderRadius: '6px',
        display: 'inline-block',
        fontWeight: '500',
      }
    },
  },

  watch: {
    showModal(newVal) {
      if (!newVal) {
        this.localTokenQuantity = 1
      }
    },
  },

  methods: {
    onClose() {
      this.$emit('closeModal')
    },

    onSubmit() {
      if (!this.localTokenQuantity || this.localTokenQuantity < 1) {
        return
      }
      this.$emit('purchase', this.localTokenQuantity)
    },
  },
}
</script>

<style lang="scss" scoped>
strong {
  color: inherit;
}

// Keep CANCEL/PURCHASE on one row, spread evenly across the full width
// instead of wrapping or bunching together, matching the same treatment
// used for the other modals on this page.
.token-modal-footer {
  flex-wrap: nowrap;
}

@media (max-width: 575.98px) {
  .token-modal-footer {
    justify-content: stretch !important;
    gap: 0.5rem;
  }

  .token-modal-btn {
    height: 44px;
    padding: 4px 14px;
    font-size: 0.85rem;
    flex: 1 1 0;
    min-width: 0;
    margin-left: 0 !important;
    margin-right: 0 !important;
  }
}
</style>
